module.exports = __webpack_public_path__ + "static/media/LARGER MID SECTION BANNER.8d503921.png";